import React, { useEffect, useState } from 'react';
import PdfViewer from './PdfViewer';

const EVENT_NAME = 'cs:open-pdf';

export const openPdfInline = (url, title) => {
  if (!url) return;
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { url, title } }));
};

const PdfViewerHost = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    console.log('[CloudSafe] PdfViewerHost mounted — listening for cs:open-pdf');
    const handler = (e) => {
      console.log('[CloudSafe] cs:open-pdf received', e.detail);
      setActive(e.detail);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  if (!active) return null;
  return (
    <PdfViewer
      url={active.url}
      title={active.title}
      onClose={() => setActive(null)}
    />
  );
};

export default PdfViewerHost;
